import Platform from './Platform'
import { store } from '../store'
import { triggerSentryError } from '../../../shared/helpers'
import configuration from '../configuration'
import { PLATFORMS } from '.'
import HLSPBSPlayer from '../../../shared/components/VideoPlayer/PlayerEngines/HlsPlayer'

const FHD_HEIGHT = 1080
const FHD_WIDTH = 1920

export class TizenPlatform extends Platform {
  _listenerId = null

  get deviceType() {
    return 'samsungtv'
  }

  get deviceModel() {
    let deviceModel = 'UNKNOWN TIZEN'
    try {
      deviceModel = window.webapis.productinfo.getModel()
    } catch (e) {
      console.error('error with window.webapis.productinfo.getModel()', e)
    }
    return deviceModel
  }

  get featureTogglePlatform() {
    return 'otter-ga-tizen'
  }

  _setCaptionsFromAPI() {
    const enabled =
      window.webapis.tvinfo.getMenuValue(
        window.webapis.tvinfo.TvInfoMenuKey.CAPTION_ONOFF_KEY
      ) === 1
        ? true
        : false
    store.dispatch({
      type: 'SET_CAPTION_STATE',
      payload: { enabled },
    })
  }

  _monitorSystemCaptions() {
    try {
      this._listenerId = window.webapis.tvinfo.addCaptionChangeListener(
        window.webapis.tvinfo.TvInfoMenuKey.CAPTION_ONOFF_KEY,
        this._setCaptionsFromAPI // call console.log inside callback to check if the value is a parameter
      )
    } catch (error) {
      const errorMessage = `Error ${
        error.status || '(unknown)'
      } monitorSystemCaptions`

      triggerSentryError(error.name, 'Tizen.js', {
        error,
        errorMessage,
        errorType: 'media',
        errorLocation: 'Tizen - CaptionsError - MonitorSystemCaptions',
      })
    }
  }

  _unmonitorSystemCaptions() {
    try {
      if (this._listenerId !== null) {
        window.webapis.tvinfo.removeCaptionChangeListener(this._listenerId)
        this._listenerId = null
      }
    } catch (error) {
      const errorMessage = `Error ${
        error.status || '(unknown)'
      } unmonitorSystemCaptions`

      triggerSentryError(error.name, 'Tizen.js', {
        error,
        errorMessage,
        errorType: 'media',
        errorLocation: 'Tizen - CaptionsError - UnmonitorSystemCaptions',
      })
    }
  }

  constructor() {
    super()
  }

  startPlayback({ sendMediaEvents = false, extraParams = {} } = {}) {
    this._monitorSystemCaptions()

    super.startPlayback({ sendMediaEvents, extraParams })
  }

  endPlayback() {
    this._unmonitorSystemCaptions()

    super.endPlayback()
  }

  getMeasurementId() {
    return configuration.analytics4.samsung.measurementId
  }

  getPlatformName() {
    return PLATFORMS.SAMSUNG
  }

  getLiveStreamAnalyticsParams() {
    return {
      video_player: configuration.analytics4.samsung.livestream_video_player,
      video_title: configuration.analytics4.samsung.livestream_video_title,
    }
  }

  getHLSConfiguration() {
    const { height, width } = window.screen
    const isFHDOrLess = height <= FHD_HEIGHT && width <= FHD_WIDTH

    return {
      capLevelToPlayerSize: isFHDOrLess,
    }
  }

  createVODPlayer(playerRef, videoPlayerProps) {
    const hlsConfig = this.getHLSConfiguration()
    return super.createPlayer(
      HLSPBSPlayer,
      playerRef,
      videoPlayerProps,
      hlsConfig
    )
  }

  createLivePlayer(playerRef, videoPlayerProps) {
    const hlsConfig = this.getHLSConfiguration()
    return super.createPlayer(
      HLSPBSPlayer,
      playerRef,
      videoPlayerProps,
      hlsConfig
    )
  }
}
